import axios from "axios";

export const TOKEN = "ESAWAS_USER_TOKEN";

export const SetAuthToken = (token?: string | null) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = token;
    axios.defaults.headers.common["frontend-source"] = "webuser";
  } else {
    delete axios.defaults.headers.common["Authorization"];
    delete axios.defaults.headers.common["frontend-source"];
  }
};

// export const useURL = process.env.REACT_APP_BASE_URL;

export const useURL =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_NODE_INTEGRATION
    ? "http://localhost:8800"
    : process.env.REACT_APP_BASE_URL;
// "http://localhost:5008";

// console.log({ useURL, env: process.env });

export const SetDefaultHeaders = () => {
  axios.defaults.baseURL = useURL;
  axios.defaults.headers.common["frontend-source"] = "webuser";
};
